import React from 'react'
import AddMoney from '../../myapp/services/add-money'

function AddMoneyPage() {
  return (
    <AddMoney/>
  )
}

export default AddMoneyPage